import * as Yup from 'yup';

export const stringSchema = message => Yup.string().required(message);
export const stringOptionalSchema = () => Yup.string();
export const emailSchema = message => Yup.string().email('Este correo es inválido, intenta de nuevo.').required(message);
export const zeroSchema = message => Yup.number().min(0, message);
export const positiveSchema = message => Yup.number().required('Debes diligenciar el campo').positive(message);
export const dateSchema = message => Yup.date().typeError('La fecha es inválida, intenta de nuevo.').required(message);
export const boolSchema = message => Yup.boolean().required(message);
export const whenStringSchema = (field, value, message) => Yup.string().when(field, { is: value, then: stringSchema(message) });
